import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SideComponent} from './components/side/side.component';
import {SideItemDirective} from './side-item.directive';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [SideComponent, SideItemDirective],
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SideComponent
  ]
})
export class CoreModule {
}
